import { render, staticRenderFns } from "./Horoscope.vue?vue&type=template&id=30a11160"
import script from "./Horoscope.vue?vue&type=script&lang=js"
export * from "./Horoscope.vue?vue&type=script&lang=js"
import style0 from "./Horoscope.vue?vue&type=style&index=0&id=30a11160&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports